import { render, staticRenderFns } from "./SubjectEditTabInformation.vue?vue&type=template&id=ade3b5aa&"
import script from "./SubjectEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./SubjectEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./SubjectEditTabInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports